export default "__VITE_ASSET__BDt0dGcr__"